import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

class SlideItem extends React.PureComponent {
  static propTypes = {
    item: PropTypes.objectOf(Object).isRequired,
    fancyboxIndex: PropTypes.string.isRequired,
    openFancyBox: PropTypes.func.isRequired,
    openGalleryPopup: PropTypes.func,
  }

  onClick = () => {
    const {
      item,
      fancyboxIndex,
      openFancyBox,
      openGalleryPopup
    } = this.props
    if(!openGalleryPopup){
      openFancyBox(fancyboxIndex, item.picture.isVideo ? 'gallery-video' : 'gallery-img')
    }

    if(openGalleryPopup){
      openGalleryPopup()
    }
  }

  render() {
    const {
      item,
      key,
    } = this.props

    const { picture } = item
    const { urlMobileSet } = picture

    return (
      <div key={key} className="item">
        <div className="item-holder">
          <div className={cn('img-holder', picture.isVideo && 'play-btn-wrap')}>
            <a
              onClick={this.onClick}
              href="javascript:void(0)"
            >
              {
                picture.isVideo && (
                  <span className="play-button" />
                )
              }
              <picture>
                {
                  urlMobileSet && (
                    urlMobileSet.map((source, index) => (
                      <source key={index} srcSet={source.url} media={source.media} />
                    ))
                  )
                }
                <img
                  height={picture.attributes.height}
                  width={picture.attributes.width}
                  src={picture.attributes['data-lazy']}
                  alt={picture.attributes.alt}
                  title={picture.attributes.title}
                />
              </picture>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default SlideItem
